import React from "react";
import Newsflow from "./Newsflow";
import Idea from "./Idea";

const Community = () => {
  return (
    <div>
      <Idea />
      <Newsflow />
    </div>
  );
};

export default Community;
